import React from 'react';
import classNames from 'classnames';
import { useIntl } from '../../../../util/reactIntl';
import css from './LanguageToggle.module.css';

const SA_FLAG = 'https://flagcdn.com/sa.svg';
const GB_FLAG = 'https://flagcdn.com/gb.svg';

/**
 * Language toggle — visual reference: NOWOffers_WebsiteCode LanguageToggle.tsx
 * Shows flag of the language to switch to + AR/EN label; uses now-app localStorage flow via onToggle.
 */
const LanguageToggle = ({ selectedLanguage, onToggle, className }) => {
  const intl = useIntl();
  const isArabic = selectedLanguage === 'Arabic';

  const showFlag = isArabic ? GB_FLAG : SA_FLAG;
  const switchLabel = isArabic ? 'EN' : 'AR';
  const ariaLabel = isArabic
    ? intl.formatMessage({ id: 'TopbarDesktop.switchToEnglish' })
    : intl.formatMessage({ id: 'TopbarDesktop.switchToArabic' });

  const handleClick = () => {
    onToggle(isArabic ? 'English' : 'Arabic');
  };

  return (
    <button
      type="button"
      className={classNames(css.toggle, className)}
      onClick={handleClick}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      <img src={showFlag} alt="" className={css.flag} />
      <span className={css.label}>{switchLabel}</span>
    </button>
  );
};

export default LanguageToggle;
